import styled from 'styled-components';

export const BroadcastersTitle = styled.div`
  font-size: var(--gameday-preview-card-title-font-size);
  line-height: var(--gameday-preview-card-title-line-height);
  font-weight: var(--gameday-card-title-font-weight);
  color: var(--gameday-card-title-color);
  margin-bottom: 16px;
`;

export const BroadcastersSection = styled.div`
  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const BroadcastersWrapper = styled.div`
  font-size: 14px;
  color: var(--gameday-broadcaster-text-color);
  font-weight: 700;
  line-height: 14px;
  font-family: var(--gameday-primary-font);
`;

export const BroadcastersSectionTitle = styled.div`
  color: var(--gameday-primary-font-color);
  margin-bottom: 8px;
`;

export const ItemList = styled.div`
  margin-top: 4px;
  font-weight: 500;
`;

export const TVSingleLine = styled.div`
  border-top: 1px solid var(--gameday-divider-color);
  border-bottom: 1px solid var(--gameday-divider-color);
  padding: 8px;
  font-size: 12px;
  font-family: var(--gameday-primary-font);
  color: var(--gameday-secondary-font-color);
  font-weight: 500;
  text-align: center;
`;
